import { AdapterCallbacks } from './adapter-callbacks';
export class AdapterCallbacksDispatcher extends AdapterCallbacks {
    logger;
    selectedAudioTrack = null;
    audioTracks = [];
    selectedSubtitlesTrack = null;
    subtitlesTracks = [];
    duration = null;
    constructor(logger) {
        super();
        this.logger = logger;
    }
    resetState() {
        this.selectedAudioTrack = null;
        this.selectedSubtitlesTrack = null;
        this.audioTracks = [];
        this.subtitlesTracks = [];
        this.duration = null;
    }
    dispatchPlayerReady = () => {
        if (this.onPlayerReady) {
            this.onPlayerReady();
        }
    };
    dispatchSelectedAudioTrackChanged = (track) => {
        this.selectedAudioTrack = track;
        this.onSelectedAudioTrackChanged?.(this.selectedAudioTrack);
    };
    dispatchPlaybackDurationChanged = (duration) => {
        this.onPlaybackDurationChanged?.(duration);
    };
    dispatchAvailableAudioTracksChanged = (audioTracks) => {
        this.audioTracks = audioTracks;
        this.onAvailableAudioTracksChanged?.(this.audioTracks);
    };
    dispatchSeeked = (position) => {
        this.onSeeked?.(position);
    };
    dispatchSelectedSubtitlesTrackChanged = (targetTrack) => {
        this.selectedSubtitlesTrack = targetTrack;
        this.onSelectedSubtitlesTrack?.(targetTrack);
    };
    dispatchAvailableSubtitleTracksChanged = (subtitleTracks) => {
        this.subtitlesTracks = subtitleTracks;
        this.onAvailableSubtitlesTracksChanged?.(subtitleTracks);
    };
    dispatchCastMediaTracksChanged = (data) => {
        this.onCastMediaTracksChanged?.(data);
    };
    dispatchCastMediaTrackSelectionChangedData = (data) => {
        this.onCastMediaTrackSelectionChanged?.(data);
    };
    dispatchPositionChange = (time) => {
        this.onPositionChanged?.(time);
    };
    dispatchSeekableRange = (seekableRange) => {
        this.onSeekableRangeChanged?.(seekableRange);
    };
    dispatchPlaybackStateChanged = (state) => {
        this.logger?.info('dispatchPlaybackStateChanged', state);
        this.onPlaybackStateChanged?.(state);
    };
    dispatchVideoBitrateChanged = (bitrate) => {
        this.onVideoBitrateChanged?.(bitrate);
    };
    dispatchError = (error) => {
        this.onError?.(error);
    };
    dispatchGeometryChanged = (size) => {
        this.onGeometryChanged?.(size);
    };
    dispatchBandwidthMeasured = (bandwidth) => {
        this.onBandwidthMeasured?.(bandwidth);
    };
    dispatchPlaybackEnded = () => {
        this.onPlaybackEnded?.();
    };
    dispatchPlay = () => {
        this.onPlay?.();
    };
    dispatchLatencyChanged = (metadata) => {
        this.onLatencyChanged?.(metadata);
    };
    dispatchDroppedFrames = (droppedFrames, elapsedMs) => {
        this.onDroppedFrames?.(droppedFrames, elapsedMs);
    };
    dispatchAdBreakStarted = (data) => {
        this.logger?.info('dispatchAdBreakStarted', data);
        this.onAdBreakStarted?.(data);
    };
    dispatchAdBreakEnded = (data) => {
        this.logger?.info('dispatchAdBreakEnded', data);
        this.onAdBreakEnded?.(data);
    };
    dispatchAdLoaded = (data) => {
        this.logger?.info('dispatchAdLoaded', data);
        this.onAdLoaded?.(data);
    };
    dispatchAdStarted = (data) => {
        this.logger?.info('dispatchAdStarted', data);
        this.onAdStarted?.(data);
    };
    dispatchAdPaused = (data) => {
        this.logger?.info('dispatchAdPaused', data);
        this.onAdPaused?.(data);
    };
    dispatchAdPositionChanged = (data) => {
        // this.logger?.info('dispatchAdPositionChanged', data);
        this.onAdPositionChanged?.(data);
    };
    dispatchAdEnded = (data) => {
        this.logger?.info('dispatchAdEnded', data);
        this.onAdEnded?.(data);
    };
    dispatchAdSkipped = (data) => {
        this.logger?.info('dispatchAdSkipped', data);
        this.onAdSkipped?.(data);
    };
    dispatchAdResumed = (data) => {
        this.logger?.info('dispatchAdResumed', data);
        this.onAdResumed?.(data);
    };
    dispatchAdMetadata = (data) => {
        this.logger?.info('dispatchAdMetadata', data);
        this.onAdMetadata?.(data);
    };
    dispatchAdError = (data) => {
        this.logger?.info('dispatchAdError', data);
        this.onAdError?.(data);
    };
    dispatchContentPauseRequested() {
        this.logger?.info('dispatchContentPauseRequested');
        this.onContentPauseRequested?.();
    }
    dispatchContentResumeRequested() {
        this.logger?.info('dispatchContentResumeRequested');
        this.onContentResumeRequested?.();
    }
    dispatchPauseAdParsed(data) {
        this.logger?.info('dispatchPauseAdParsed', data);
        this.onPauseAdParsed?.(data);
    }
    dispatchAdBreakSkipAvailable() {
        this.logger?.info('dispatchAdBreakSkipAvailable');
        this.onAdSkipAvailable?.();
    }
    dispatchAdBreakSkipUnavailable() {
        this.logger?.info('dispatchAdBreakSkipUnavailable');
        this.onAdSkipUnavailable?.();
    }
    dispatchAdFirstQuartile(data) {
        this.logger?.info('dispatchAdFirstQuartile', data);
        this.onAdFirstQuartile?.(data);
    }
    dispatchAdMidpoint(data) {
        this.logger?.info('dispatchAdMidpoint', data);
        this.onAdMidpoint?.(data);
    }
    dispatchAdThirdQuartile(data) {
        this.logger?.info('dispatchAdThirdQuartile', data);
        this.onAdThirdQuartile?.(data);
    }
}
